import React from 'react';
import { Box, Container, Typography, Button, Paper } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../common/LanguageSwitcher';
import SalovareLogo from '../common/SalovareLogo';
import LegalFooterLinks from './LegalFooterLinks';
import PageSeo from '../seo/PageSeo';
import MarketingLanguageLinks from '../seo/MarketingLanguageLinks';
import useLocalizedMarketingPath from '../../hooks/useLocalizedMarketingPath';
import { BRAND, BRAND_RADIUS } from '../../theme/brandTokens';

const LegalPageLayout = ({ title, seoDescription, path, children }) => {
  const { t } = useTranslation();
  const localizePath = useLocalizedMarketingPath();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: BRAND.background,
        py: { xs: 3, md: 5 },
      }}
    >
      <PageSeo title={`${title} | Salovare`} description={seoDescription} path={path} />
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, gap: 2 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            component={RouterLink}
            to={localizePath('/')}
            sx={{ color: BRAND.accentText, textTransform: 'none', fontWeight: 600 }}
          >
            {t('legal.common.backToHome')}
          </Button>
          <LanguageSwitcher variant="compact" sx={{ mb: 0, minWidth: 110 }} />
        </Box>

        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: BRAND_RADIUS.card,
            border: `1px solid ${BRAND.line}`,
            background: BRAND.surface,
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
            <SalovareLogo />
          </Box>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 800, color: BRAND.text, mb: 1, textAlign: 'center' }}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 4 }}>
            {t('legal.common.lastUpdated')}
          </Typography>

          {children}
        </Paper>

        <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <LegalFooterLinks />
          <MarketingLanguageLinks path={path} />
        </Box>
      </Container>
    </Box>
  );
};

export default LegalPageLayout;
